// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Cormorant Garamond', 'Cormorant Garamond Fallback'"},"className":"__className_7eb19e"};